// The admin's flash: a short confirmation that something saved, drawn once by
// the shell. Each flash is its own, so saving twice shows it twice.

interface Flash {
	text: string;
	n: number;
}

let current = $state<Flash | null>(null);
let shown = 0;

export function currentFlash(): Flash | null {
	return current;
}

export function flash(text: string): void {
	shown += 1;
	current = { text, n: shown };
}

export function clearFlash(): void {
	current = null;
}
